import { configureStore, createListenerMiddleware, addListener } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { rtkQueryErrorLogger, unauthenticatedMiddleware } from 'middlewares'
import { axiosApi } from 'services/api'
import authReducer from 'features/auth/authSlice'
import appReducer from 'features/auth/appSlice'
import patientsReducer from 'features/patients-list/patientSlice'
import collectionsReducer from 'features/collections-list/collectionSlice'
import patientDetailsReducer from 'features/patient-details/patientDetailsSlice'
import collectionDetailsReducer from 'features/collection-details/collectionDetailsSlice'
import fileReducer from 'features/file-view/fileSlice'
import thumbnailReducer from 'features/patient-file-thumbnail/thumbnailSlice'
import notificationReducer from 'features/bell-notification/notificationSlice'
import favoriteReducer from 'features/favorite/favoriteSlice'
import syncReducer from 'features/sync-data/syncSlice'

const listenerMiddlewareInstance = createListenerMiddleware({
    onError: () => console.error,
})

export const store = configureStore({
    reducer: {
        auth: authReducer,
        app: appReducer,
        patients: patientsReducer,
        collections: collectionsReducer,
        patientStudies: patientDetailsReducer,
        collectionSudies: collectionDetailsReducer,
        files: fileReducer,
        thumbnails: thumbnailReducer,
        notifications: notificationReducer,
        favorites: favoriteReducer,
        sync: syncReducer,
        [axiosApi.reducerPath]: axiosApi.reducer,
    },
    middleware: getDefaultMiddleware => [
        ...getDefaultMiddleware(),
        listenerMiddlewareInstance.middleware,
        rtkQueryErrorLogger,
        unauthenticatedMiddleware,
        axiosApi.middleware,
    ],
})

export const startAppListening = listenerMiddlewareInstance.startListening
export const addAppListener = addListener

setupListeners(store.dispatch)
